<template>
  <div class="promo">
    <div class="promo_title"><v-icon>new_releases</v-icon>프로모션</div>
    <template v-if="promoCnt !== 0">
      <div class="promo_content" v-for="(promo, n) in promotions" :key="n">
        <img :src="promo.banner_url" alt="promotion"
          @click="clickHandler($event, promo.landing_url)" />
      </div>
    </template>
    <template v-if="promoCnt === 0">
      <!-- <div class="no_promo">현재 진행중인 프로모션이 없습니다.</div> -->
      <div class="promocontents">
      <img src="https://interview.interworksmedia.co.kr/interview/static/img/inteplay_launching.jpg" alt="down"/>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import {isMobile} from '@/assets/func'

  export default {
    name: 'promotion',
    data () {
      return {
        isMobile: false
      }
    },
    methods: {
      clickHandler (e, url) {
        if (!this.isMobile) {
          var pop
          let promo = new Image()
          promo.onload = function () {
            let x = Math.floor((screen.availWidth - parseInt(this.width)) / 2)
            let y = Math.floor((screen.availHeight - parseInt(this.height)) / 2)
            pop = window.open(url,
              '_blank',
              'width=' + this.width + ',height=' + this.height +
              ',top=' + y + ',left=' + x + ',status=no,toolbar=no,scrollbars=no')
            if (!pop) {
              alert('팝업이 차단되어있습니다. 팝업을 허용해 주시기 바랍니다.')
            }
          }
          promo.src = url
        } else {
          window.open(url,
              '_blank',
              'status=no,toolbar=no,scrollbars=no')
        }
      }
    },
    computed: {
      ...mapState({
        promotions: state => state.promotion.promoList,
        promoCnt: state => state.promotion.promoCnt
      })
    },
    created () {
      this.isMobile = isMobile()
    }
  }
</script>

<style scoped>
  .promo_title {
    margin-left: 10px;
    height: 30px;
    line-height: 30px;
    color: #689f38;
    font-weight: 500;
  }
  i {
    vertical-align: middle;
    margin-right: 5px;
  }
  .promocontents {
    text-align: center;
  }
  .promo_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .promo_content img {
    width: calc(100% - 20px);
    height: auto;
    max-width: 450px;
    margin-bottom: 10px;
  }
  .promo_content img:hover {
    cursor: pointer;
  }
  .no_promo {
    height: 40px;
    line-height: 20px;
    text-align: center;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// Promotion.vue?76d839a1